import * as React from "react";
import { observer } from "mobx-react";
import { IShotsResultsParams } from "./IShotsResultsParams";
import { PlayerInfo } from "./../PlayerInfo/PlayerInfo";
import { ResultsTable } from "./../ResultsTable/ResultsTable";
import { ReportKind } from "Data";

@observer
export class ShotsResults extends React.Component<IShotsResultsParams>{
    constructor(props: IShotsResultsParams) {
        super(props, undefined);
    }

    render() {
        return <div className="ShotsResults table-wrapper">
            {this.props.individualPlayers &&
                this.props.individualPlayers.map((currentPlayer, i) => {
                    return <div className="player-and-results-table-wrapper" key={i}>
                        {this.props.individualPlayers.length > 1 && (this.props.reportKind === ReportKind.multiGroupReport || this.props.reportKind === ReportKind.singleGroupReport || this.props.reportKind === ReportKind.puttingMultiGroupReport || this.props.reportKind === ReportKind.puttingSingleGroupReport || this.props.reportKind === ReportKind.drShotAnalysis) &&
                            <PlayerInfo currentPlayer={currentPlayer} isWeb={this.props.isWeb}></PlayerInfo>
                        }
                        {this.props.measurementsData.map((measurementGroup, i) => {
                            if (measurementGroup.player && currentPlayer.id === measurementGroup.player.id) {
                                return <ResultsTable 
                                    key={i} 
                                    reportKind={this.props.reportKind} 
                                    measurementsData={this.props.measurementsData} 
                                    measurementGroup={measurementGroup} 
                                    groupIndex={i} 
                                    displayStrokesGroup={this.props.displayStrokesGroup} 
                                    unitPresentation={this.props.unitPresentation} 
                                    measurementParameters={this.props.measurementParameters} 
                                    isWeb={this.props.isWeb} 
                                    selectedStroke={this.props.selectedStroke} 
                                    selectedAverage={this.props.selectedAverage} 
                                    selectedGroupOfStrokes={this.props.selectedGroupOfStrokes} 
                                    tilesToDisplay={this.props.tilesToDisplay} 
                                    selectShot={this.props.selectShot} 
                                    selectVideo={this.props.selectVideo} 
                                    hideSingleShot={this.props.hideSingleShot} 
                                    selectAverage={this.props.selectAverage} 
                                    collapseStrokesGroup={this.props.collapseStrokesGroup} 
                                    disableTile={this.props.disableTile} 
                                    addTile={this.props.addTile} 
                                    updateUnitOnTiles={this.props.updateUnitOnTiles} 
                                    loadTiles={this.props.loadTiles} 
                                    changeUnit={this.props.changeUnit} 
                                    setAdditionalInfoUrl={this.props.setAdditionalInfoUrl} 
                                    selectedUnit={this.props.selectedUnit} 
                                    reportStore={this.props.reportStore}>
                                </ResultsTable>;
                            }
                            return null;
                        })}
                    </div>;
                })}
        </div >;
    }
}
